import { render } from "./ContentHeader.vue?vue&type=template&id=714934c5"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"
script.render = render

export default script